import {
    PDF_EXPORT_STYLES_FONT_SIZE_DEFAULT,
    PDF_EXPORT_STYLES_PAGE_ORIENTATION_DEFAULT,
    PDF_EXPORT_STYLES_PAGE_SIZE_DEFAULT
} from "@containers/export/containers/pdf/constants";
import {generateExportStylesPdfBaseSettings} from "@containers/export/containers/pdf/helpers/settings";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IExportDataSetItem} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {ExportPdfContent, IExportPdfBaseSettings, IPdfExportStyles} from "@containers/export/containers/pdf/types";
import {TDocumentDefinitions} from "pdfmake/interfaces";
import {buildWidth} from "@containers/export/containers/pdf/helpers/buildWidth";
import {buildBody} from "@containers/export/containers/pdf/helpers/buildBody";


export const stylesBuildColumnCbPdf = (dataSet: IExportDataSetItem[]) => {
    if (!dataSet?.length) {
        return {}
    }
    let styles: Record<string, IPdfExportStyles> = {}

    dataSet.forEach((item) => {
        const {columns} = item;
        if (!columns?.length) {
            return
        }
        columns.forEach((col) => {
            if (!(('id') in col)) {
                return
            }
            if (col?.exportStyles?.pdf) {
                styles[col['id'] as string] = col?.exportStyles?.pdf;
            }
        })
    })
    return styles;
}


export const buildExportDataPdf = <T>({
                                          dataSet,
                                          baseSettings,
                                          baseSettingsCb = generateExportStylesPdfBaseSettings,
                                          headerContents = [],
                                      }: {
    dataSet: IExportDataSetItem[],
    baseSettings?: IExportPdfBaseSettings,
    baseSettingsCb?: (columns: IColumnItem<any>[], dataSet: IExportDataSetItem<any>) => IExportPdfBaseSettings,
    headerContents?: ExportPdfContent,
}): TDocumentDefinitions => {
    if (!dataSet?.length) {
        return {
            content: []
        }
    }
    let currentBaseSettings = baseSettings;
    const styles = stylesBuildColumnCbPdf(dataSet)
    const content: ExportPdfContent = []

    const rootDataSet = dataSet.find((dataSet) => dataSet.rootDataSet)
    const rootDataSetColumns = rootDataSet.columns.filter((column) => !column.hideExport)
    currentBaseSettings = baseSettingsCb(rootDataSetColumns, rootDataSet)

    if (dataSet?.length) {
        dataSet.forEach((dataSetItem) => {
            if(dataSetItem?.settings?.hidePdfExport){
                return
            }
            const {
                columns,
                rootDataSet,
                ySteps
            } = dataSetItem;

            const currentColumns = columns.filter((column) => !column.hideExport)

            const autoSize = currentColumns.find((column) => column?.exportStyles?.pdf?.width && column.exportStyles.pdf.width !== '*')

            const widths = buildWidth({
                columns: currentColumns,
                autoSize: !!autoSize,
                baseSettings: currentBaseSettings,
            })

            const body = buildBody(dataSetItem)
            content.push({
                layout: rootDataSet ? undefined : 'lightHorizontalLines',
                table: {
                    widths,
                    body,

                },
                margin: ySteps ? [0, 0, 0, ySteps * 5] : [],
            } as any)
        })
    }


    return {
        pageSize: currentBaseSettings?.pageSize ?? PDF_EXPORT_STYLES_PAGE_SIZE_DEFAULT,
        pageOrientation: currentBaseSettings?.pageOrientation === 'auto' ? undefined : currentBaseSettings?.pageOrientation || PDF_EXPORT_STYLES_PAGE_ORIENTATION_DEFAULT,
        styles: {
            "tableHeader": {
                "bold": true,
                "fontSize": currentBaseSettings?.tableHeader?.fontSize ?? 8,
                "color": "white",
                "fillColor": "#2d4154",
                "alignment": "center"
            },
            "tableBodyEven": {},
            "tableBodyOdd": {
                "fillColor": "#f3f3f3"
            },
            "tableFooter": {
                "bold": true,
                "fontSize": 11,
                "color": "white",
                "fillColor": "#2d4154"
            },
            header: {
                "bold": true,
                "fontSize": currentBaseSettings?.header?.fontSize ?? 11,
                "color": "black",
                "fillColor": "#2d4154",
                "alignment": "center",
                margin: [0, 0],
            },
            ...styles,

        },
        "defaultStyle": {
            "fontSize": currentBaseSettings?.fontSize || PDF_EXPORT_STYLES_FONT_SIZE_DEFAULT
        },
        "compress": true,
        content: [
            ...(Array.isArray(headerContents) ? headerContents : []),
            ...content
        ],
        pageMargins: [10, 10, 10, 10],
    }
}